<!-- Sfondo immagine -->
<div
  class="sfondo-immagine"
  *ngIf="sfondoUrl"
  [style.background-image]="'url(' + sfondoUrl + ')'"
></div>

<div class="iscrizione-page">
  <div class="container">
    <!-- Loading -->
    <div class="loading" *ngIf="loading">
      <div class="spinner"></div>
      <p>Caricamento form...</p>
    </div>

    <!-- Error -->
    <div class="error-message" *ngIf="errorMessage && !loading">
      <p>{{ errorMessage }}</p>
      <a routerLink="/eventi">← Torna agli eventi</a>
    </div>

    <!-- Iscrizioni chiuse -->
    <div
      class="iscrizioni-chiuse"
      *ngIf="
        !loading && !errorMessage && eventoInfo && !eventoInfo.iscrizioniAperte
      "
    >
      <h2>Iscrizioni chiuse</h2>
      <p>Le iscrizioni per questo evento non sono al momento aperte.</p>
    </div>

    <!-- Form -->
    <ng-container
      *ngIf="
        !loading &&
        !errorMessage &&
        formConfig &&
        eventoInfo?.iscrizioniAperte &&
        !isSuccess
      "
    >
      <h1 class="page-title">{{ formConfig.titolo }}</h1>
      <p class="evento-title">{{ eventoInfo?.titolo }}</p>

      <!-- Sezione Descrizione -->
      <div class="descrizione-section" *ngIf="descrizioneHtml">
        <div class="descrizione-card" [innerHTML]="descrizioneHtml"></div>
      </div>

      <!-- Sezione Programma / Timeline -->
      <div class="programma-section" *ngIf="formConfig.programma?.length">
        <h2 class="programma-title">Programma</h2>
        <div class="timeline">
          <div
            class="timeline-item"
            *ngFor="let giorno of formConfig.programma"
          >
            <div class="timeline-marker">
              <span class="timeline-day">{{ giorno.giorno }}</span>
              <span class="timeline-date">{{ giorno.data }}</span>
            </div>
            <div class="timeline-content">
              <h3 class="timeline-heading">{{ giorno.titolo }}</h3>
              <div class="timeline-events">
                <div
                  class="timeline-event"
                  *ngFor="let evento of giorno.eventi"
                >
                  <span class="event-time">{{ evento.orario }}</span>
                  <span class="event-desc">{{ evento.descrizione }}</span>
                  <span class="event-place" *ngIf="evento.luogo">{{
                    evento.luogo
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Step indicators -->
      <div class="step-indicators" *ngIf="formConfig.steps.length > 1">
        <ng-container *ngFor="let step of formConfig.steps; let i = index">
          <div
            class="step-indicator"
            [class.active]="i < currentStep"
            [class.current]="i === currentStep"
          >
            <div class="step-number">{{ i + 1 }}</div>
            <div class="step-label">{{ step.titolo }}</div>
          </div>
          <div
            class="step-line"
            *ngIf="i < formConfig.steps.length - 1"
            [class.active]="i < currentStep"
          ></div>
        </ng-container>
      </div>

      <!-- Current step -->
      <div class="form-card" #formCard>
        <ng-container *ngIf="currentStepConfig">
          <h2 class="section-title">{{ currentStepConfig.titolo }}</h2>
          <p class="section-description" *ngIf="currentStepConfig.descrizione">
            {{ currentStepConfig.descrizione }}
          </p>

          <div class="fields-grid">
            <ng-container *ngFor="let field of currentStepConfig.campi">
              <ng-container *ngIf="isFieldVisible(field)">
                <!-- Product cards (Stripe) -->
                <div
                  *ngIf="field.blockType === 'campo-prodotti-stripe'"
                  class="field-full"
                >
                  <app-dynamic-product-cards
                    [field]="field"
                    [value]="formData[field.nome]"
                    (valueChange)="onFieldChange(field.nome, $event)"
                    (priceChange)="onProductPriceChange(field.nome, $event)"
                  ></app-dynamic-product-cards>
                </div>

                <!-- File upload -->
                <div
                  *ngIf="field.blockType === 'campo-file'"
                  [class.field-full]="field.larghezza !== 'half'"
                >
                  <app-dynamic-file-upload
                    [field]="field"
                    [eventoId]="eventoInfo?.id || ''"
                    (fileUploaded)="onFileUploaded($event)"
                    (fileRemoved)="onFileRemoved($event)"
                  ></app-dynamic-file-upload>
                </div>

                <!-- All other fields -->
                <div
                  *ngIf="
                    field.blockType !== 'campo-file' &&
                    field.blockType !== 'campo-prodotti-stripe'
                  "
                  [class.field-full]="field.larghezza !== 'half'"
                >
                  <app-dynamic-field
                    [field]="field"
                    [value]="formData[field.nome]"
                    (valueChange)="onFieldChange(field.nome, $event)"
                  ></app-dynamic-field>
                </div>
              </ng-container>
            </ng-container>
          </div>

          <!-- Price summary on last step -->
          <app-dynamic-price-summary
            *ngIf="isLastStep && calculatedPrice > 0"
            [totalPrice]="calculatedPrice"
            [accontoAmount]="totalAcconto"
            [breakdown]="priceBreakdown"
          ></app-dynamic-price-summary>

          <!-- Privacy on last step -->
          <div
            class="privacy-section"
            *ngIf="isLastStep && formConfig.privacy?.mostraDialogPrivacy"
          >
            <div class="privacy-check">
              <input
                type="checkbox"
                id="privacy"
                [(ngModel)]="privacyAccepted"
              />
              <label class="privacy-label" for="privacy">
                Ho letto e accetto l'<a
                  (click)="showPrivacyDialog = true; $event.preventDefault()"
                  >informativa sulla privacy</a
                >
              </label>
            </div>
          </div>
        </ng-container>

        <!-- Submit error -->
        <div class="submit-error" *ngIf="submitError">{{ submitError }}</div>

        <!-- Submitting -->
        <div class="submitting" *ngIf="submitting">
          <div class="spinner"></div>
          <p>Invio in corso...</p>
        </div>

        <!-- Navigation -->
        <div class="form-navigation" *ngIf="!submitting">
          <button
            class="btn btn-prev"
            *ngIf="currentStep > 0"
            (click)="prevStep()"
          >
            ← Indietro
          </button>
          <button
            class="btn btn-next"
            *ngIf="!isLastStep"
            (click)="nextStep()"
            [disabled]="!isCurrentStepValid()"
          >
            Avanti →
          </button>
          <button
            class="btn btn-submit"
            *ngIf="isLastStep"
            (click)="onSubmit()"
            [disabled]="!isFormValid() || submitting"
          >
            {{ submitButtonLabel }}
          </button>
        </div>
      </div>
    </ng-container>

    <!-- Success -->
    <div class="success-container" *ngIf="isSuccess">
      <div class="success-icon">&#10003;</div>
      <h2>Iscrizione completata!</h2>
      <p>{{ successMessage }}</p>
      <div
        class="payment-instructions"
        *ngIf="paymentInstructionsHtml"
        [innerHTML]="paymentInstructionsHtml"
      ></div>
    </div>
  </div>
</div>

<!-- Privacy dialog -->
<app-dynamic-privacy-dialog
  [visible]="showPrivacyDialog"
  [privacyHtml]="privacyHtml"
  (accepted)="onPrivacyAccepted()"
  (closed)="showPrivacyDialog = false"
></app-dynamic-privacy-dialog>
